'use client'

import { ButtonSecondary } from '@fukku/button/Secondary'
import { useShopTheLook } from 'cross-selling/contexts/ShopTheLookProvider/ShopTheLookProvider'
import type { CrossSellingServiceResponse } from 'cross-selling/types'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { type JSX, useEffect } from 'react'
import { useAnalytics } from '../../../contexts/AnalyticsProvider/AnalyticsProvider'
import styles from './ShopTheLookButton.module.scss'

type ShopTheLookButtonProps = {
	readonly products: CrossSellingServiceResponse[]
	readonly productId: string
	readonly colorId: string
	readonly lookId: string
}

export function ShopTheLookButton({
	products,
	productId,
	colorId,
	lookId,
}: ShopTheLookButtonProps): JSX.Element | null {
	const { sendShopTheLookOpenEvent } = useAnalytics()
	const { setIsOpen, setProducts } = useShopTheLook()
	const { t } = useLabels()
	const { isShop } = useMasterData()

	const onShopTheLookClick = (): void => {
		sendShopTheLookOpenEvent()
		setIsOpen(true)
	}

	useEffect(() => {
		const pdpProduct = { productId, colorId, lookId }
		setProducts([pdpProduct, ...products])
	}, [products])

	return isShop ? (
		<ButtonSecondary
			data-testid='pdp.shopTheLook.button'
			onClick={onShopTheLookClick}
			className={styles.shopTheLookButton}
		>
			{t('pdp.getTheLook.button')}
		</ButtonSecondary>
	) : null
}
